module.exports = __webpack_public_path__ + "static/media/logo-black.289ebb97.svg";